import * as React from 'react'

import { Helmet } from 'react-helmet-async'
import { NotificationLayout } from '../../layouts'

const NotificationPage = (): React.ReactElement => (
  <>
    <Helmet>
      <title>Notifications</title>
      <meta name="description" content="ImageKit notifications" />
    </Helmet>
    <NotificationLayout />
  </>
)

export default NotificationPage
